(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui-universal/primitive-utilities"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities")) : factory(root["underscore"], root["@bingads-webui-universal/primitive-utilities"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 144);
/******/ })
/************************************************************************/
/******/ ({

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(145);


/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.odataCast = exports.odataUri = exports.odataQuery = void 0;

var odataQuery = _interopRequireWildcard(__webpack_require__(146));

exports.odataQuery = odataQuery;

var odataUri = _interopRequireWildcard(__webpack_require__(147));

exports.odataUri = odataUri;

var odataCast = _interopRequireWildcard(__webpack_require__(148));

exports.odataCast = odataCast;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convert = convert;

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DefaultTop = 20;

function convert({
  where = {},
  expand,
  limit,
  offset,
  orderBy,
  query,
  select,
  source,
  any
} = {}) {
  const ret = {};

  const _where$ = where['*'],
        _where$2 = _where$ === void 0 ? {} : _where$,
        search = _where$2.contains;

  if (!_underscore.default.isEmpty(search)) {
    ret.$search = search;
  }

  if (_underscore.default.isString(where) && !_underscore.default.isEmpty(where)) {
    // If 'where' is a string, then directly use it as '$filter' without any further conversion.
    // In this case, 'where' is a well-formed, non-URL-encoded string, such as:
    // "(PerformanceMetrics/Clicks gt 10 and contains(Name, 'Campaign')
    // and HasAuctionInsight eq true)"
    ret.$filter = where;
  }

  if (!_underscore.default.isEmpty(expand) && _underscore.default.isArray(expand)) {
    ret.$expand = expand.join(',');
  }

  if (_underscore.default.isNull(limit) || _underscore.default.isUndefined(limit)) {
    ret.$top = DefaultTop;
  } else if (!_underscore.default.isNumber(limit) || _underscore.default.isNaN(limit)) {
    throw new TypeError('limit must be a number and not NaN');
  } else if (limit !== Number.MAX_VALUE) {
    ret.$top = limit;
  }

  if (!_underscore.default.isUndefined(offset)) {
    ret.$skip = offset;
  }

  ret.$count = true;

  if (!_underscore.default.isUndefined(source)) {
    ret.$source = source;
  } // todo [akamel] only supports one order column
  // todo [akamel] this expects mongo style orderby obj; rely on js-data syntax for this instead...


  if (!_underscore.default.isEmpty(orderBy)) {
    if (_underscore.default.isString(orderBy)) {
      ret.$orderby = `${orderBy} asc`;
    } else if (_underscore.default.isArray(orderBy)) {
      const arr = orderBy.map(item => {
        if (_underscore.default.isString(item)) {
          return `${item} asc`;
        } else if (_underscore.default.isArray(item)) {
          return `${item[0]} ${item[1].toLowerCase()}`;
        } else if (_underscore.default.isObject(item)) {
          const name = _underscore.default.keys(item)[0];

          const direction = item[name] > 0 ? 'asc' : 'desc';
          return `${name} ${direction}`;
        }

        return null;
      }).filter(item => item);
      ret.$orderby = arr.join(',');
    }
  }

  if (!_underscore.default.isEmpty(select)) {
    ret.$select = select.join(',');
  }

  if (_underscore.default.isObject(any)) {
    _underscore.default.each(_underscore.default.keys(any), key => {
      const value = any[key];

      if (_underscore.default.isString(value)) {
        ret[key] = any[key];
      }
    });
  }

  return _underscore.default.extend(ret, _underscore.default.omit(query, 'entitySet'));
}

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convert = convert;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var odataCast = _interopRequireWildcard(__webpack_require__(148));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCast({
  cast = null
}) {
  return _underscore.default.isEmpty(cast) ? '' : `/${cast}`;
}

function getParent({
  parent = null
}) {
  return _underscore.default.isEmpty(parent) ? '' : `${parent}/`;
} // TODO: wewei, ericwa, remove the parent/cast in existing code


function getUriLegacy(definition, options, id) {
  if (options.url) {
    return options.url;
  }

  const name = `${definition.name}s`;

  const idType = _underscore.default.chain(definition).result('schema').result('properties').result(definition.idAttribute).result('type').value();

  if (!_underscore.default.isNull(id)) {
    if (_underscore.default.isString(id) && (idType === 'string' || !idType)) {
      return `/Customers(:advertisercustomer_id)/Accounts(:account_id)/${getParent(options)}${name}('${id}')${getCast(options)}`;
    }

    return `/Customers(:advertisercustomer_id)/Accounts(:account_id)/${getParent(options)}${name}(${id})${getCast(options)}`;
  }

  return `/Customers(:advertisercustomer_id)/Accounts(:account_id)/${getParent(options)}${name}${getCast(options)}`;
}

function convert({
  definition,
  options = {},
  id = null,
  isFinding = false,
  entitySet = options.entitySet
}) {
  if (entitySet) {
    // NOTICE: Change made here to pass in advertiserCustomerID
    // instead of pulling from component/state.
    const _options$useAdvertise = options.useAdvertiserCustomerId,
          useAdvertiserCustomerId = _options$useAdvertise === void 0 ? true : _options$useAdvertise,
          advertiserCustomerID = options.advertiserCustomerID;
    const searchId = useAdvertiserCustomerId && entitySet.Accounts ? advertiserCustomerID : id;
    let resIds = _underscore.default.isNull(searchId) ? entitySet : entitySet.$withKey(searchId);

    if (isFinding) {
      resIds = odataCast.resIds({
        resIds,
        definition,
        options
      });
    }

    return resIds.odataURL;
  }

  return getUriLegacy(definition, options, id);
}

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resIds = resIds;
exports.data = data;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _primitiveUtilities = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function needCast(definition, options) {
  // _.has means has own, it will not check property in __proto__
  const jsdataResource = _underscore.default.has(options, 'entitySet') ? (0, _primitiveUtilities.get)(options, 'entitySet.type.elementType.jsdataResource') : (0, _primitiveUtilities.get)(options, 'entitySet.jsdataResource');
  return !_underscore.default.isEmpty(jsdataResource) && definition !== jsdataResource;
}

function resIds({
  resIds: ids,
  definition,
  options
}) {
  return needCast(definition, options) ? ids.$cast(`Model.${definition.name}`) : ids;
}

function data({
  data: d,
  definition,
  options
}) {
  const extra = needCast(definition, options) ? {
    '@odata.type': `Model.${definition.name}`
  } : {};
  return _underscore.default.extend(extra, d);
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ });
});
